import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';
import { Route, Router, Switch } from 'react-router-dom';

// Root
import { useTeamVisibility } from '@atlassian/ptc-common';
import KudosPage from './KudosPage';
import MyProfileRedirect from './MyProfileRedirect';
import RootRedirect from './RootRedirect';
// Search
import { RouteWithOrgIdLoading } from './RouteWithOrgIdLoading';
import SearchPage from './SearchPage';
// User Profile
import SearchTeamsError from './SearchTeamsError';
import TeamProfile from './TeamProfile';
import TeamProfileNoId from './TeamProfileNoId';
import UserProfile from './UserProfile';
import UserProfileUnknownRoute from './UserProfileUnknownRoute';
import UserProfileWorkedOn from './UserProfileWorkedOn';

// Team Profile

// Kudos

const renderRoutes = (contextEntryPoint, canViewTeams) => {
  return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: `${contextEntryPoint}/`,
    render: RootRedirect
  }), !canViewTeams && /*#__PURE__*/React.createElement(Route, {
    path: `${contextEntryPoint}/search/teams`,
    render: SearchTeamsError
  }), /*#__PURE__*/React.createElement(Route, {
    path: `${contextEntryPoint}/search`,
    render: SearchPage
  }), /*#__PURE__*/React.createElement(Route, {
    path: `${contextEntryPoint}/kudos/:uuid`,
    render: KudosPage
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: `${contextEntryPoint}/team`,
    render: TeamProfileNoId
  }), /*#__PURE__*/React.createElement(RouteWithOrgIdLoading, {
    path: `${contextEntryPoint}/team/:teamId`,
    render: TeamProfile
  }), /*#__PURE__*/React.createElement(Route, {
    path: `${contextEntryPoint}/:userId/work`,
    render: UserProfileWorkedOn
  }), /*#__PURE__*/React.createElement(Route, {
    path: `${contextEntryPoint}/:userId/*`,
    render: UserProfileUnknownRoute
  }), /*#__PURE__*/React.createElement(Route, {
    path: `${contextEntryPoint}/me`,
    render: props => /*#__PURE__*/React.createElement(MyProfileRedirect, _extends({}, props, {
      contextEntryPoint: contextEntryPoint
    }))
  }), /*#__PURE__*/React.createElement(Route, {
    path: `${contextEntryPoint}/:userId`,
    render: UserProfile
  }));
};
function AppRoutes(props) {
  const {
    contextEntryPoint,
    history,
    onTransition
  } = props;
  const {
    permissions: {
      canViewTeams
    }
  } = useTeamVisibility();
  useEffect(() => {
    if (!onTransition) {
      return;
    }
    let unsubscribeBlockingHistory = () => {};
    let unsubscribeListeningHistory = () => {};
    if (history) {
      let lastHistoryLocation;
      unsubscribeListeningHistory = history.listen(({
        pathname
      }) => {
        lastHistoryLocation = pathname;
      });

      // We're using history.block() here instead of history.listen()
      // because we want this to run BEFORE transition happens.
      unsubscribeBlockingHistory = history.block(({
        pathname
      }) => {
        if (lastHistoryLocation !== pathname) {
          onTransition(pathname);
        }
      });
    }
    return () => {
      unsubscribeBlockingHistory();
      unsubscribeListeningHistory();
    };
  }, [onTransition, history]);
  const routes = renderRoutes(contextEntryPoint, canViewTeams);

  // If `history` object is not passed to `EmbeddableDirectory`, `EmbeddableDirectory` will use `Router` component from product in higher component tree.
  // If `history` object is passed to `EmbeddableDirectory`, `EmbeddableDirectory` will render its own `Router` component.
  return history ? /*#__PURE__*/React.createElement(Router, {
    history: history
  }, routes) : routes;
}
export default AppRoutes;